var map = {
	"./auPlat-on.svg": "7a7c",
	"./brouilles-blanc-on.svg": "6106",
	"./brouilles-on.svg": "39dd",
	"./coque-on.svg": "5e41",
	"./dur-on.svg": "3b79",
	"./omelette-blanc-on.svg": "8afe",
	"./omelette-on.svg": "31cc",
	"./poches-on.svg": "2b1e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "91b3";